export default __webpack_public_path__ + "static/media/Lip_7_M.68b1002f.svg";